<template>
  <v-snackbar
    v-model="show"
    :color="color === 'error' ? 'deep-orange darken-3' : color"
    :bottom="y === 'bottom'"
    :left="x === 'left'"
    :multi-line="mode === 'multi-line'"
    :right="x === 'right'"
    :timeout="timeout"
    :top="y === 'top'"
    :vertical="mode === 'vertical'"
  >
    <div v-html="message" />
    <v-btn
      dark
      flat
      @click="show = false"
    >
      關閉
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      reqiured: true
    },
    x: String,
    y: String,
    mode: String,
    color: String,
    timeout: {
      type: Number,
      default () {
        return 3000
      }
    }
  },
  data () {
    return {
      show: false
    }
  },
  mounted () {
    this.show = true
  }
}
</script>
